import styled from "styled-components/macro";
import { colorState, radius, spacing, typography } from "components/Foundation";
import { filterWidth } from "../../curb/filter/styles";

export const ToastDiv = styled.div`
    .Toastify__toast-container {
        width: fit-content;
        max-width: 450px;
    }

    .Toastify__toast {
        border-radius: ${radius.radius_8};
        border: none;
        font-size: ${typography.size.tm};
        font-weight: ${typography.weight.regular};
        gap: ${spacing.spacing_12};
        position: relative;
        padding: ${spacing.spacing_12} ${spacing.spacing_16};
        overflow: auto;
        cursor: pointer;
        align-items: center;
    }

    .Toastify__close-button {
        stroke-width: 0;
    }

    .Toastify__close-button {
        opacity: 1;
        display: flex;
    }

    .Toastify__toast-body {
        padding: 0;
        gap: ${spacing.spacing_12};
    }

    .Toastify__toast-container--bottom-center {
        bottom: 9px;
    }

    .Toastify__toast-container--bottom-right {
        margin-left: 600px;
        bottom: 9px;
    }

    .toast-message-container {
        display: flex;
    }

    .Toastify__toast-icon {
        margin-inline-end: 0;
    }

    .Toastify__toast--dark {
        background-color: ${colorState.surface.default["primary-inverse"]};
        color: ${colorState.text["primary-inverse"]};
        border: 1px solid ${colorState.border.default.hairline};
    }

    .Toastify__toast--light {
        background-color: ${colorState.surface.default.primary};
        color: ${colorState.text["primary-inverse"]};
        border: 1px solid ${colorState.border.default.primary};
    }

    .Toastify__toast--success {
        background-color: ${colorState.surface.success.primary};
        color: ${colorState.text["primary-inverse"]};
        border: 1px solid ${colorState.border.success.primary};
    }

    .Toastify__toast--info {
        background-color: ${colorState.surface.info.primary};
        color: ${colorState.text["primary-inverse"]};
        border: ${colorState.border.info.primary};
    }

    .Toastify__toast--warning {
        background-color: ${colorState.surface.warning.primary};
        color: ${colorState.text["primary-inverse"]};
        border: ${colorState.border.warning.primary};
    }

    .Toastify__toast--error {
        background-color: ${colorState.surface.danger.primary};
        color: ${colorState.text["primary-inverse"]};
        border: ${colorState.border.danger.primary};
    }
`;
